import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function getNavLabel(id) {
  switch (id) {
    case 'billing':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.billing"
      });
    case 'billing.subscriptions':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.subscriptions"
      });
    case 'billing.invoices':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.invoices"
      });
    case 'billing.payment-methods':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.paymentMethods"
      });
    case 'billing.payment-history':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.paymentHistory"
      });
    case 'billing.quotes':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.billing.quotes"
      });
    case 'work':
    case 'teamwork':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.work.work"
      });
    case 'home-app':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.home.home"
      });
    case 'onboarding':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.customerSuccess.onboarding"
      });
    case 'tickets':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.customerPortal.tickets"
      });
    case 'deals':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.dealRooms.deal"
      });
    case 'reference':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.reference"
      });
    case 'reference.component-examples':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.componentExamples"
      });
    case 'reference.translation-examples':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.translationExamples"
      });
    case 'reference.token-explorer':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.tokenExplorer"
      });
    case 'reference.projects':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.projects"
      });
    case 'reference.forms':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "nav.reference.forms"
      });
    default:
      return id;
  }
}